import game from './game';

const api_requests = {
	game,
};

export default api_requests;
